export default __webpack_public_path__ + "static/media/5.b7009e7e.svg";